import React from "react";
import { useNavigate } from "react-router-dom";

const LmsReadmore = () => {
  const navigate = useNavigate()
  const styles = {
    container: {
      maxWidth: '1100px',
      margin: '0 auto',
      padding: '40px 20px',
      fontFamily: '"Inter", "Segoe UI", sans-serif',
      color: '#2d3436',
      lineHeight: '1.7',
    },
    heroSection: {
      textAlign: 'center',
      marginBottom: '60px',
    },
    sectionCard: {
      background: '#ffffff',
      borderRadius: '20px',
      padding: "25px 30px 0px 30px",
      marginBottom: '40px',
      boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
      border: '1px solid #f1f2f6',
    },
    imageWrapper: {
      width: '100%',
      borderRadius: '15px',
      overflow: 'hidden',
      marginBottom: '30px',
      boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
    },
    img: {
      width: '100%',
      height: '400px',
      display: 'block',
      objectFit: 'cover',
    },
    impactBanner: (bgcolor) => ({
      background: bgcolor,
      padding: "30px 30px",
      borderRadius: "30px",
      textAlign: "center",
      margin: "15px 0",
    }),
    h1: {
      fontSize: '2.8rem',
      fontWeight: '800',
      color: '#0984e3',
      lineHeight: '1.05',
      marginBottom: '24px',
    },
    h2: {
      fontSize: '2rem',
      color: '#2d3436',
      borderLeft: '5px solid #0984e3',
      paddingLeft: '20px',
      marginBottom: '20px',
    },
    h3: {
      fontSize: '1.4rem',
      color: '#0984e3',
      // marginTop: '30px',
      marginBottom: '15px',
      fontWeight: '700',
    },
    p: {
      fontSize: '1.2rem',
      marginBottom: '20px',
      color: '#636e72',
    },
    ul: {
      listStyle: 'none',
      padding: '0',
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '20px',
      margin: '30px 0',
    },
    li: {
      background: '#e7e6f7',
      padding: '20px',
      borderRadius: '12px',
      borderBottom: '3px solid #0984e3',
      fontSize: "1rem"
    },
    accentBox: {
      background: "linear-gradient(90deg, rgba(207, 66, 66, 1) 1%, rgba(204, 49, 49, 0.25) 100%)",
      color: '#ffffff',
      padding: '40px',
      borderRadius: '20px',
      textAlign: 'center',
      marginTop: '60px',
    },
    phaseCard: (color, bgColor) => ({
      borderLeft: `8px solid ${color}`,
      background: bgColor,
      padding: '10px 40px',
      borderRadius: '16px',
      marginBottom: '30px',
      boxShadow: '0 10px 25px rgba(0,0,0,0.03)',
      position: 'relative',
    }),
    milestone: {
      display: 'inline-block',
      background: '#00b894',
      color: 'white',
      padding: '8px 20px',
      borderRadius: '50px',
      fontWeight: 'bold',
      fontSize: '1rem',
      marginTop: '20px',
      textTransform: 'uppercase',
      letterSpacing: '1px',
    },
    featuresGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
      gap: '25px',
      margin: '20px 0',
    },
    featureItem: {
      padding: '25px',
      background: '#f8f9fa',
      borderRadius: '12px',
      border: '1px solid #edf2f7',
    },
    ctaBox: {
      background: '#e1f5fe',
      padding: '50px',
      borderRadius: '30px',
      textAlign: 'center',
      marginTop: '80px',
    },
    sectionDivider: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      margin: "15px 0",
      position: "relative",
    },
    dividerLine: {
      height: "2px",
      width: "100%",
      backgroundColor: "#dfe6e9",
      position: "absolute",
    },
    dividerDot: {
      width: "40px",
      height: "6px",
      backgroundColor: "#0984e3",
      borderRadius: "10px",
      zIndex: 1,
    },

    adaptationWrapper: {
        display: "flex",
        flexWrap: "wrap",
        gap: "20px",
        marginTop: "30px",
      },
  
      adaptationBox: (color) => ({
        flex: "1",
        minWidth: "320px",
        padding: "20px",
        borderRadius: "20px",
        border: `1px solid ${color}33`,
        backgroundColor: `${color}14`,
      }),
  };

  return (
    <div className="read-more-container">
      <div className="menu-container">
        {/* --- HERO SECTION --- */}
        <div className="ps-rm-section-card" style={{marginTop: "140px" }}>
          <div
            style={{marginBottom: "20px" }}
            className="enrollment-image-card ps-rm-image-wrapper"
          >
            <img
              src="../images/product&soluction/read-more/sisReadmore1.jpg"
              alt="SIS Overview"
              className="ps-rm-image"
            />
          </div>
          <h1 className="ps-rm-h1">Stusphere Learning Management System (LMS)</h1>
          <p
            className="ps-rm-text"
          >
            Empower Education with a Seamless, All-in-One Learning Platform
          </p>
          <p className="ps-rm-text">
            Stusphere is a powerful, modern Learning Management System (LMS)
            designed to support hybrid, fully online, and traditional classroom
            learning. Whether you're an individual educator, a school, a
            university, or a corporate training provider, Stusphere provides the
            tools you need to create, deliver, and manage engaging educational
            experiences at scale.
          </p>
        </div>
        <div className="ps-rm-divider">
        <div className="ps-rm-divider-line"></div>
        <div className="ps-rm-divider-dot"></div>
      </div>
        {/* --- KEY CAPABILITIES --- */}
        <div className="ps-rm-section-card">
          <h2 className="ps-rm-h2">Key Capabilities</h2>
          <div style={styles.phaseCard("#6c5ce7", "#f3f0ff")}>
            <h3 className="ps-rm-h3">Flexible Course Delivery</h3>
            <p className="ps-rm-text">
              •⁠ Support for fully online, hybrid, and blended learning models.
            </p>
            <p className="ps-rm-text">
              •⁠ Easily create and manage courses with multimedia content: videos,
              interactive quizzes, assignments, discussion forums, live virtual
              classrooms, and SCORM-compliant materials.
            </p>
            <p className="ps-rm-text">
              •⁠ Seamless integration with third-party learning tools and platforms
              (Google Classroom, Microsoft Teams, Zoom, Canvas, Moodle, and more) to
              bring all your existing resources into one unified environment.
            </p>
          </div>
          <div style={styles.phaseCard("#00b894", "#e8f5e9")}>
            <h3 className="ps-rm-h3">Advanced Content Creation & Organization</h3>
            <p className="ps-rm-text">
              •⁠ Drag-and-drop course builder for structuring modules, lessons, and
              learning paths.
            </p>
            <p className="ps-rm-text">
              •⁠ Adaptive learning paths that adjust based on student performance.
            </p>
            <p className="ps-rm-text">
              •⁠ Rich content library with reusable assets, templates, and
              collaborative authoring tools for teams.
            </p>
          </div>
          <div style={styles.phaseCard("#0984e3", "#e1f5fe")}>
            <h3 className="ps-rm-h3">Comprehensive Student Progress Tracking</h3>
            <p className="ps-rm-text">
              •⁠ Real-time progress reports for each course, showing completion
              rates, time spent, and engagement metrics at individual, class, and
              institution levels.
            </p>
            <p className="ps-rm-text">
              •⁠ Detailed dashboards with visual analytics: charts, heatmaps, and
              timelines to identify at-risk students early.
            </p>
            <p className="ps-rm-text">
              •⁠ Customizable milestones and learning objectives tracking to ensure
              alignment with curriculum standards.
            </p>
          </div>
          <div style={styles.phaseCard("#f39c12", "#fff9e6")}>
            <h3 className="ps-rm-h3">Robust Grading & Assessment System</h3>
            <p className="ps-rm-text">
              •⁠ Automated and manual grading options for quizzes, assignments,
              essays, and peer reviews.
            </p>
            <p className="ps-rm-text">
              •⁠ Flexible grading scales, rubrics, and weighted categories.
            </p>
            <p className="ps-rm-text">
              •⁠ Instant feedback delivery to students with comments, annotations,
              and video/audio responses.
            </p>
            <p className="ps-rm-text">
              •⁠ Gradebook with exportable reports, curve adjustments, and
              integration with institutional student information systems (SIS).
            </p>
            <p className="ps-rm-text">
              •⁠ Plagiarism detection integration and proctoring tools for secure
              online assessments.
            </p>
          </div>
        </div>
        <div style={styles.sectionDivider}>
          <div style={styles.dividerLine}></div>
          <div style={styles.dividerDot}></div>
        </div>
        {/* --- FEATURE GRID SECTIONS --- */}
        <div className="ps-rm-section-card">
          <div className="ps-rm-features-grid">
            {/* PERSONALIZED LEARNING CARD */}
            <div
              style={styles.adaptationBox("#6c5ce7")}
              className="readmore-card-hover-border"
            >
              <h3 className="ps-rm-h3" style={{ color: "#6c5ce7", marginTop: 0 }}>
                Personalized Learning Experience
              </h3>
              <p className="ps-rm-text">
                • AI-driven recommendations for supplementary resources based on
                performance.
              </p>
              <p className="ps-rm-text">
                • Individual learning plans and competency-based progression.
              </p>
              <p className="ps-rm-text">
                • Mobile-friendly access for learning anytime, anywhere.
              </p>
            </div>
            {/* COLLABORATION & COMMUNICATION CARD */}
            <div
              style={styles.adaptationBox("#0984e3")}
              className="readmore-card-hover-border"
            >
             <h3 className="ps-rm-h3" style={{ color: "#6c5ce7", marginTop: 0 }}>
                Collaboration & Communication
              </h3>
              <p className="ps-rm-text">
                • Built-in forums, messaging, announcements, and group projects.
              </p>
              <p className="ps-rm-text">
                • Live sessions with recording and playback capabilities.
              </p>
              <p className="ps-rm-text">
                • Parent/guardian portals for monitoring progress (K-12 focused).
              </p>
            </div>
          </div>
          <div className="ps-rm-section-card">
            <h3 className="ps-rm-h3">Admin & Institutional Tools</h3>
            <ul className="ps-rm-list">
              <li
                style={{ ...styles.li, backgroundColor: "#eaf4ff" }}
                className="readmore-card-hover"
              >
                Role-based access control (admins, instructors, students,
                observers).
              </li>
              <li
                style={{ ...styles.li, backgroundColor: "#f3edff" }}
                className="readmore-card-hover"
              >
                Bulk user management and single sign-on (SSO) support.
              </li>
              <li
                style={{ ...styles.li, backgroundColor: "#e9fbf8" }}
                className="readmore-card-hover"
              >
                Compliance with GDPR, FERPA, and accessibility standards (WCAG).
              </li>
              <li
                style={{ ...styles.li, backgroundColor: "#fff6e5" }}
                className="readmore-card-hover"
              >
                Custom branding and white-label options for institutions.
              </li>
              <li
                style={{ ...styles.li, backgroundColor: "#fae1dd" }}
                className="readmore-card-hover"
              >
                Audit logs and activity tracking for transparency and security
                monitoring.
              </li>
              <li
                style={{ ...styles.li, backgroundColor: "#eae4e9" }}
                className="readmore-card-hover"
              >
                API access and integrations with SIS, CRM, and third-party tools.
              </li>
            </ul>
          </div>
        </div>
        {/* --- WHY CHOOSE SECTION --- */}
        <div style={styles.impactBanner("#e1f5fe")}>
          <h2>Why Choose Stusphere?</h2>
          <p className="ps-rm-text">
            Stusphere goes beyond traditional LMS platforms by offering deep
            integration capabilities, actionable progress insights, and a
            student-centered design that drives better outcomes. Our system
            empowers educators to focus on teaching while providing administrators
            and learners with clear, data-driven visibility into performance and
            growth.
          </p>
        </div>
        {/* --- FINAL CTA --- */}
        <div style={styles.impactBanner("#6c5ce72b")}>
          <h2>Ready to transform your educational delivery?</h2>
          <p className="ps-rm-text">
            Stusphere – Where learning connects, progresses, and succeeds.
          </p>
          <div
            style={{
              display: "flex",
              gap: "20px",
              justifyContent: "center",
              marginTop: "5px",
              flexWrap: "wrap",
            }}
          >
            {/* Button 1: Start Free Trial (Green Theme) */}
            <div
              className="read-more-btn"
              style={{
                backgroundColor: "#00b894",
                color: "white",
                padding: "12px 24px",
                borderRadius: "8px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => navigate("/contact#Contact-form")}
            >
              Start Your Free Trial <span style={{ marginLeft: "8px" }}>→</span>
            </div>
            {/* Button 2: Schedule Demo (Blue Theme) */}
            <div
              className="read-more-btn"
              style={{
                backgroundColor: "#ef4444",
                color: "white",
                padding: "12px 24px",
                borderRadius: "8px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => navigate("/contact#Contact-form")}
            >
              Schedule a Demo <span style={{ marginLeft: "8px" }}>→</span>
            </div>
            {/* Button 3: Custom Integration (Purple Theme) */}
            <div
              className="read-more-btn"
              style={{
                backgroundColor: "#6c5ce7",
                color: "white",
                padding: "12px 24px",
                borderRadius: "8px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => navigate("/contact#Contact-form")}
            >
              Contact Sales for Custom Integration{" "}
              <span style={{ marginLeft: "8px" }}>→</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LmsReadmore;